import { useDispatch } from 'react-redux';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';
import type { InjectedRouter } from 'react-router';
import RevisionActions from '../../../actions/RevisionActions';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { formatTimestamp, trimString } from '../../../utils';
import Icon, { icons } from '../../generic/Icon';
import type { ProjectDashboardRevision, RevisionRouteParams } from '../projectDashboardTypes';

type Props = {
  params: RevisionRouteParams;
  revision: ProjectDashboardRevision;
  routerPush: InjectedRouter['push'];
};

const getScanButtonLabel = (scannedAt: string) => (
  <span>
    <span className="full">Scanned: {formatTimestamp(scannedAt)}</span>
    <span className="abbr">Scans</span>
  </span>
);

const renderRevisionScans = (revision: ProjectDashboardRevision) => revision.data.revisionScans.map(revScan => (
  <MenuItem
    active={revScan.id === revision.data?.selectedRevisionScan?.id}
    eventKey={revScan.id}
    key={revScan.id}
  >
    {formatTimestamp(revScan.scanned_at)}
  </MenuItem>
));

const ProjectSummaryIssueScanDropdown: VoidFunctionComponent<Props> = ({
  params,
  revision,
  routerPush,
}) => {
  const dispatch = useDispatch();

  const onSelect = (revisionScanId: number) => {
    //  Set the new selected revision ID in Reflux
    RevisionActions.selectRevisionScan(revision.data.locator, revisionScanId);
    //  Handle setting the scope. Places where we `useCategorySummary` will smell an update to scope and re-fetch the category summary.
    if (revisionScanId) {
      dispatch(IssuesV2Store.actions.setScanId(revisionScanId));
      //  Add it to the URL in a query param.
      routerPush({
        pathname: window.location.pathname,
        search: `?revisionScanId=${revisionScanId}`,
      });
    }
  };

  return (
    <b className="inline-header">
      Issues in {trimString(params.reference, 15)}
      {revision.data?.selectedRevisionScan && revision.data?.revisionScans?.length > 1 &&
        <>
          <Icon icon={icons.angleRight} />
          <DropdownButton
            className="dropdown-mid choose-scan inline-header"
            key={revision.data.selectedRevisionScan.id}
            title={getScanButtonLabel(revision.data?.selectedRevisionScan?.scanned_at)}
            onSelect={onSelect}
          >
            {renderRevisionScans(revision)}
          </DropdownButton>
        </>}
    </b>
  );
}
export default ProjectSummaryIssueScanDropdown;
